import jwt from 'jwt-decode';
import { JWTokenPayload } from '../views/Login/login/helpers/decodeJwt';

export const decodeAccessToken = <T extends keyof SessionData>(key: T): SessionData[T] => {
  const token = sessionStorage.getItem('accessToken')
  const json: JWTokenPayload = token ? jwt<JWTokenPayload>(token) : INITIAL_SESSION_DATA
  const sessionData: SessionData = {
    alias: json.alias,
    idUser: Number(json.userId),
    isAdmin: json.role === 'admin',
    username: json.user,
    service: json.service.service,
    idService: Number(json.service.serviceId),
    idCountry: Number(json.service.countryId),
    mandatoryField: Boolean(json.service.mandatoryField),
    dateCreated: json.service.dateCreated
  }
  return sessionData[key]
}

interface SessionData {
  [key: string]: string | number | boolean
  alias: string
  idUser: number
  service: string
  isAdmin: boolean
  idService: number
  username: string
  dateCreated: string
  idCountry: number
}

const INITIAL_SESSION_DATA: JWTokenPayload = {
  alias: '',
  role: '',
  serviceId: 0,
  user: '',
  userId: 0,
  service: {
    country: '',
    countryId: 0,
    dateCreated: '',
    service: '',
    serviceId: 0,
    mandatoryField: 'true'
  }
}
